import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, FileText } from "lucide-react";
import TeroumaLogo from "./ui/TeroumaLogo";

/**
 * Pied de page « site » des pages publiques partagées par lien — le pendant
 * de PublicSiteHeader : navy, logo, navigation courte et réassurance
 * (paiement sécurisé, reçu Cerfa). Autonome, se monte en une ligne.
 */
export default function PublicSiteFooter() {
  return (
    <footer className="mt-16" style={{ background: "#0D1B33" }}>
      <div className="max-w-7xl mx-auto px-5 sm:px-6 py-10">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div>
            <TeroumaLogo size={34} variant="full" onDark textColor="#FFFFFF" />
            <p className="text-xs text-white/50 mt-2 max-w-xs leading-relaxed">
              La plateforme de dons des synagogues — engagements, reçus Cerfa
              et relances, sans effort.
            </p>
          </div>
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-white/75">
            <Link to="/" className="hover:text-white transition-colors">Accueil</Link>
            <Link to="/organisations" className="hover:text-white transition-colors">Synagogues</Link>
            <Link to="/campagnes" className="hover:text-white transition-colors">Campagnes</Link>
            <Link to="/kiddoush" className="hover:text-white transition-colors">Kiddoush</Link>
            <Link to="/contact" className="hover:text-white transition-colors">Contact</Link>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-white/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-[11px] text-white/55">
            <span className="inline-flex items-center gap-1.5">
              <ShieldCheck className="h-3.5 w-3.5" style={{ color: "#B8962E" }} />
              Paiement 100 % sécurisé · Stripe
            </span>
            <span className="inline-flex items-center gap-1.5">
              <FileText className="h-3.5 w-3.5" style={{ color: "#B8962E" }} />
              Reçu fiscal Cerfa automatique
            </span>
          </div>
          <p className="text-[11px] text-white/40">
            © {new Date().getFullYear()} Terouma
          </p>
        </div>
      </div>
    </footer>
  );
}
